import { createContext, ReactNode } from 'react'

import { ArcadeModalProps } from './ArcadeModal'

export type CustomModalHeader = ReactNode

/**
 * Modal action overrides.
 * Provide button props to override back/close buttons, or CustomHeader to replace the entire header.
 */
export type ArcadeModalActionOverride =
  | {
      type: 'buttons'
      backButtonProps?: Partial<ArcadeModalProps['backButtonProps']>
      closeButtonProps?: Partial<ArcadeModalProps['closeButtonProps']>
    }
  | {
      type: 'customHeader'
      CustomHeader: CustomModalHeader
    }

type ArcadeModalActionContextValue = {
  actionOverride: ArcadeModalActionOverride | undefined
  setActionOverride: (override: ArcadeModalActionOverride | undefined) => void
}

const error = () => {
  throw Error('ArcadeModalActionProvider not found')
}

export const ArcadeModalActionContext = createContext<ArcadeModalActionContextValue>({
  actionOverride: undefined,
  setActionOverride: error,
})
